import configStore from "../../stores/ConfigStore";

import { FeedbackRequest } from "./FeedbackRequest";

export default class FeedbackService {

    public static async patchAsync(feedback: FeedbackRequest): Promise<FeedbackRequest> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/feedback`, {
            body: JSON.stringify(feedback),
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "PATCH",
        })
        .then(p => p.json())
    }
}
